;(function() {
  'use strict'

  Controller.$inject = ["$scope", "glUtils"];
  angular.module('app.core').component('surveyExplorerSelect', {
    controller: Controller,
    templateUrl: 'survey-explorer-select.html',
    bindings: {
      kind: '<',
      options: '<',
      value: '<',
      search: '<',
      onChange: '&',
      canConfigure: '<',
      onConfigure: '&',
      readOnly: '<',
    },
  })

  var activeMenu = null

  /* @ngInject */
  function Controller($scope, glUtils) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy
    ctrl.getOption = getOption
    ctrl.onQueryChange = onQueryChange
    ctrl.isVisible = isVisible
    ctrl.onOpen = onOpen
    ctrl.onClose = onClose
    ctrl.select = select
    ctrl.selectSub = selectSub
    ctrl.hasSubOptions = hasSubOptions
    ctrl.showDivider = showDivider
    ctrl.configure = configure

    function hasSubOptions() {
      return _.some(ctrl.options, function(o) {
        return o.subOptions && o.subOptions.length
      })
    }

    function onInit() {
      ctrl.id = glUtils.uuid()
    }

    function onDestroy() {
      if (activeMenu === ctrl.menu) activeMenu = null
    }

    function onOpen() {
      activeMenu = ctrl.menu
    }

    function getOption() {
      var exact = _.find(ctrl.options, { id: ctrl.value })
      if (exact) return exact
      // composite value: "<parentId>:<subId>"
      var value = ctrl.value
      if (typeof value !== 'string' || value.indexOf(':') === -1) return null
      var sep = value.lastIndexOf(':')
      var parentId = value.slice(0, sep)
      var subId = value.slice(sep + 1)
      var parent = _.find(ctrl.options, { id: parentId })
      if (!parent || !parent.subOptions) return null
      var sub = _.find(parent.subOptions, { id: subId })
      if (!sub) return null
      return { id: value, label: parent.label + ' — ' + sub.label }
    }

    function onQueryChange(value) {
      ctrl.queryRegex = value ? new RegExp(value, 'i') : null
    }

    function isVisible(option) {
      if (option.hidden) return false
      if (ctrl.queryRegex) {
        return ctrl.queryRegex.test(option.label)
      }
      return true
    }

    function onClose() {
      ctrl.query = ''
      onQueryChange()
      if (activeMenu === ctrl.menu) activeMenu = null
    }

    function select(option) {
      if (option.subOptions && option.subOptions.length) return
      ctrl.onChange({ $value: option.id })
    }

    function selectSub(option, subOption) {
      ctrl.onChange({ $value: option.id + ':' + subOption.id })
    }

    // Variable slots list the axis-placement options ('rows', 'columns') first,
    // then the items you can pin to. Draw a separator after 'columns' — but only
    // when there's a visible pin option below it. Slots without axes (sort,
    // format) have no 'columns' option, so they never get a divider.
    function showDivider(option) {
      if (option.id !== 'columns') return false
      return _.some(ctrl.options, function(o) {
        return o.id !== 'rows' && o.id !== 'columns' && isVisible(o)
      })
    }

    function configure(event) {
      event.preventDefault()
      event.stopPropagation()
      if (activeMenu) activeMenu.close()
      ctrl.onConfigure({})
    }
  }
})()
